<template><el-card shadow="never" class="aui-card--fill">
  <el-form :inline="true" :model="dataForm">
    <el-form-item>
      <el-select
        v-model="dataForm.agentId"
        filterable
        remote
        clearable
        :remote-method="searchAgents"
        :loading="agentLoading"
        placeholder="请输入一级代理用户名"
        style="width: 260px;">
        <el-option
          v-for="agent in agentOptions"
          :key="agent.id"
          :label="agentLabel(agent)"
          :value="agent.id" />
      </el-select>
    </el-form-item>
    <el-form-item><el-input v-model="dataForm.lineUrl" placeholder="线路地址" clearable style="width: 300px;"/></el-form-item>
    <el-form-item><el-select v-model="dataForm.status" placeholder="状态" clearable><el-option label="启用" :value="1"/><el-option label="禁用" :value="2"/></el-select></el-form-item>
    <el-form-item><el-button @click="search">查询</el-button><el-button type="primary" @click="openEditor()">新增</el-button></el-form-item>
  </el-form>
  <el-table v-loading="loading" :data="dataList" border>
    <el-table-column prop="id" label="ID" width="90"/>
    <el-table-column prop="agent_username" label="代理账号" width="110"/>
    <el-table-column label="线路地址" min-width="360">
      <template slot-scope="s">
        <div class="line-url-cell">
          <span class="line-url-text" :title="lineUrl(s.row)">{{ lineUrl(s.row) }}</span>
          <el-button
            type="text"
            icon="el-icon-document-copy"
            title="复制线路地址"
            aria-label="复制线路地址"
            @click="copyLineUrl(s.row)" />
        </div>
      </template>
    </el-table-column>
    <el-table-column prop="createTime" label="创建时间" width="180"/>
    <el-table-column label="状态" width="100"><template v-slot="s"><el-tag :type="statusType(s.row.status)">{{ statusText(s.row.status) }}</el-tag></template></el-table-column>
  
    <el-table-column label="操作" width="150"><template v-slot="s"><el-button type="text" @click="openEditor(s.row)">编辑</el-button><el-button type="text" @click="toggleStatus(s.row)">{{ s.row.status === 1 ? '禁用' : '启用' }}</el-button></template></el-table-column>
  </el-table>
  <el-pagination :current-page="page" :page-size="limit" :total="total" :page-sizes="[10,20,50,100]" layout="total, sizes, prev, pager, next, jumper" @size-change="sizeChange" @current-change="currentChange"/>
  <el-dialog :title="form.id ? '编辑线路' : '新增线路'" :visible.sync="visible" width="680px">
    <el-alert
      v-if="!form.id"
      title="只能给一级代理配置线路"
      type="info"
      :closable="false"
      style="margin-bottom: 20px;" />
    <el-form ref="form" :model="form" :rules="rules" label-width="100px">
      <el-form-item label="代理" prop="agentId">
        <el-select
          v-model="form.agentId"
          filterable
          remote
          :disabled="!!form.id"
          :remote-method="searchLineAgents"
          :loading="lineAgentLoading"
          placeholder="请输入一级代理用户名"
          style="width: 100%;">
          <el-option
            v-for="agent in lineAgentOptions"
            :key="agent.id"
            :label="agentLabel(agent)"
            :value="agent.id" />
        </el-select>
      </el-form-item>
      <el-form-item label="线路地址" prop="lineUrl">
        <el-input
          v-model="form.lineUrl"
          placeholder="请输入 http:// 或 https:// 开头的地址" />
      </el-form-item>
      <el-form-item label="状态">
        <el-switch
          v-model="form.status"
          :active-value="1"
          :inactive-value="2"
          active-text="启用"
          inactive-text="禁用" />
      </el-form-item>
    </el-form>
    <span slot="footer">
      <el-button @click="visible = false">取消</el-button>
      <el-button type="primary" @click="submit">确定</el-button>
    </span>
  </el-dialog>
</el-card></template>
<script>
import agentPage from '@/mixins/agent-page'

const empty = () => ({
  id: '',
  agentId: '',
  lineUrl: '',
  status: 1
})

export default {
  mixins: [agentPage],
  data () {
    return {
      pageUrl: '/agent-line/page',
      dataForm: {
        agentId: '',
        lineUrl: '',
        status: ''
      },
      agentLoading: false,
      agentOptions: [],
      lineAgentLoading: false,
      lineAgentOptions: [],
      visible: false,
      form: empty(),
      rules: {
        agentId: [
          { required: true, message: '请选择一级代理', trigger: 'change' }
        ],
        lineUrl: [
          { required: true, message: '请输入线路地址', trigger: 'blur' },
          {
            pattern: /^https?:\/\/\S+$/i,
            message: '线路地址必须以 http:// 或 https:// 开头',
            trigger: 'blur'
          }
        ]
      }
    }
  },
  methods: {
    lineUrl (row) {
      const baseUrl = row.url.replace(/\/+$/, ''); // 去掉右侧所有 "/"
      return `${baseUrl}/?inviteCode=${row.member_code}`
    },
    copyLineUrl (row) {
      const input = document.createElement('input')
      input.value = this.lineUrl(row)
      document.body.appendChild(input)
      input.select()

      try {
        const copied = document.execCommand('copy')
        if (!copied) throw new Error('copy command failed')
        this.$message.success('线路地址已复制到剪贴板')
      } catch (err) {
        this.$message.error('复制失败，请手动复制')
      } finally {
        document.body.removeChild(input)
      }
    },
    searchAgents (username) {
      const keyword = username.trim()
      if (!keyword) {
        this.agentOptions = []
        return
      }

      this.agentLoading = true
      this.$http.get('/agent/page', {
        params: {
          level: 1,
          username: keyword,
          page: 1,
          limit: 20
        }
      }).then(({ data }) => {
        if (data.code !== 0) {
          this.agentOptions = []
          return this.$message.error(data.msg)
        }
        this.agentOptions = data.data.list || []
      }).finally(() => {
        this.agentLoading = false
      })
    },
    agentLabel (agent) {
      const nickname = agent.nickname ? ` - ${agent.nickname}` : ''
      return `${agent.username}${nickname}（ID: ${agent.id}）`
    },
    searchLineAgents (username) {
      const keyword = username.trim()
      if (!keyword) {
        this.lineAgentOptions = []
        return
      }

      this.lineAgentLoading = true
      this.$http.get('/agent/page', {
        params: {
          level: 1,
          username: keyword,
          page: 1,
          limit: 20
        }
      }).then(({ data }) => {
        if (data.code !== 0) {
          this.lineAgentOptions = []
          return this.$message.error(data.msg)
        }
        this.lineAgentOptions = data.data.list || []
      }).finally(() => {
        this.lineAgentLoading = false
      })
    },
    openEditor (row) {
      this.form = row
        ? { ...empty(), ...row, lineUrl: row.lineUrl || row.url }
        : empty()
      this.lineAgentOptions = row
        ? [{ id: row.agentId, username: `代理 ${row.agentId}`, nickname: '' }]
        : []
      this.visible = true
    },
    submit () {
      this.$refs.form.validate(valid => {
        if (!valid) {
          return
        }

        const request = this.form.id
          ? this.$http.put(`/agent-line/${this.form.id}`, this.form)
          : this.$http.post('/agent-line', this.form)

        request.then(({ data }) => {
          if (data.code !== 0) {
            return this.$message.error(data.msg)
          }
          this.$message.success('保存成功')
          this.visible = false
          this.getDataList()
        })
      })
    },
    toggleStatus (row) {
      const status = row.status === 1 ? 2 : 1
      this.$http.put(`/agent-line/${row.id}/status`, { status })
        .then(({ data }) => {
          if (data.code !== 0) {
            return this.$message.error(data.msg)
          }
          this.getDataList()
        })
    }
  }
}
</script>
<style scoped>
.line-url-cell {
  display: flex;
  align-items: center;
}

.line-url-text {
  overflow: hidden;
  flex: 1;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.line-url-cell .el-button {
  flex: none;
  margin-left: 8px;
}
</style>
